import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/shared/uikit/ToastV2";
import { useIgnoreConnection } from "@/react/hooks/connections/useIgnoreConnection";
import { invalidateAllMemberQueries } from "./util";

export const useIgnoreConnectionForUser = ({
  memberPublicUid,
}: {
  memberPublicUid?: string;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: ignoreConnection, isLoading: isIgnoring } =
    useIgnoreConnection({
      onSuccess: async () => {
        await invalidateAllMemberQueries(queryClient, memberPublicUid ?? "");
        toast.success(
          t("profile_drawer.connect_banner.messages.connection_ignored"),
        );
      },
      onError: () => {
        toast.error(
          t("profile_drawer.connect_banner.messages.connection_ignore_error"),
        );
      },
    });

  return {
    ignoreConnectionForUser: ignoreConnection,
    isIgnoring,
  };
};
